
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LocaleSwitch',
  props: {
  },
  methods: {
    changeLocale: function (locale: string) {
      this.$i18n.locale = locale
      this.$store.commit('changeLocale', locale)
      localStorage.setItem('locale', locale)

      if (locale === 'fr') {
        document.title = "Joris Broll | Ingénieur en logiciels web à Mulhouse"
      } else if (locale === 'en') {
        document.title = "Joris Broll | Web Software Engineer in Mulhouse"
      }
    }
  },
  created() {
    const storedLocale = localStorage.getItem('locale')

    if (storedLocale == null) {
      this.$i18n.locale = 'fr'
      this.$store.commit('changeLocale', 'fr')
    } else {
      this.$i18n.locale = storedLocale
      this.$store.commit('changeLocale', storedLocale)
    }
  },
});
